// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mFEZ","colBig":"styles_colBig__1lVLj","colSmall":"styles_colSmall__1_BdC"};